import React from "react";
import { Row, Col, CardTitle } from "reactstrap";
import { ClipLoader } from "react-spinners";
import BootstrapTable from "react-bootstrap-table-next";

const CustomTable = ({ data, columns, tableName, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center" }}>
        <ClipLoader size={90} color="#1d8cf8" loading={loading} />
        <br />
        <br />
        <h1 className="text-info">Carregando ...</h1>
      </div>
    );
  }

  if (!columns || columns.length === 0 || !data || data.length === 0) {
    return (
      <div style={{ textAlign: "center" }}>
        <h4 className="text-info">Nenhum dado disponível para exibir.</h4>
      </div>
    );
  }

  const columnsFormatted = columns.map((col) => {
    const columnConfig = {
      dataField: col.dataField,
      text: col.text,
      sort: false,
      // Outros estilos ou propriedades
    };

    // Alinhar a coluna '#' (campo 'name') à esquerda
    if (col.dataField === "name") {
      columnConfig.align = "left"; // Alinha as células de dados à esquerda
      columnConfig.headerAlign = "left"; // Alinha o cabeçalho à esquerda (opcional)
      columnConfig.headerClasses = "resumo-divergencias-table__header resumo-divergencias-table__header--label";
    } else {
      // Alinha as outras colunas à direita para leitura de valores
      columnConfig.align = "right";
      columnConfig.headerAlign = "right";
      columnConfig.headerClasses = "resumo-divergencias-table__header resumo-divergencias-table__header--value";
    }

    return columnConfig;
  });

  return (
    <>
      <Row style={{ alignItems: "center" }}>
        <Col md={3}>
          <CardTitle tag="h4">
            <i className="tim-icons icon-paper" /> {tableName}
          </CardTitle>
        </Col>
      </Row>
      <hr />
      <div
        className="resumo-divergencias-table-container"
        tabIndex={0}
        role="region"
        aria-label={`${tableName} - utilize a rolagem horizontal para visualizar todos os meses`}
      >
        <BootstrapTable
          keyField="name"
          data={data}
          columns={columnsFormatted}
          noDataIndication="Consulta não retornou dados."
          bordered={false}
          striped
          wrapperClasses="resumo-divergencias-table-wrapper"
          classes="resumo-divergencias-table"
        />
      </div>
    </>
  );
};

export default CustomTable;
